import React, { useEffect, useState } from "react";
import axios from "axios";

const QRCodeTable = () => {
  const [qrcodes, setQRCodes] = useState([]);
  const [filteredQRCodes, setFilteredQRCodes] = useState([]);
  const [selectedQRCode, setSelectedQRCode] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const qrcodesPerPage = 10;


  const  userId =sessionStorage.getItem('userId')

  // useEffect(() => {
  //   const fetchQRCodes = async () => {
  //     try {
  //       const response = await axios.get(`https://qrapi.emedha.in/api/qrcodes?userId=${userId}`); // Replace with dynamic userId
  //       setQRCodes(response.data.qrcodes);
  //     } catch (error) {
  //       console.error("Error fetching QR codes:", error);
  //     }
  //   };

  //   fetchQRCodes();
  // }, []);


  useEffect(() => {
    const fetchQRCodes = async () => {
      try {
        const response = await axios.get(
          `https://qrapi.emedha.in/api/qrcodes?userId=${userId}`
        );
        const nonEmptyQRCodes = response.data.qrcodes.filter(qr => qr.qrcodeImage !== '');
        setQRCodes(nonEmptyQRCodes);
        setFilteredQRCodes(nonEmptyQRCodes);
      } catch (error) {
        console.error("Error fetching QR codes:", error);
      }
    };

    fetchQRCodes();
  }, [])

  const getFileType = (url) => {
    if (url.endsWith(".mp4") || url.endsWith(".mkv")) return "Video";
    if (url.startsWith("http://") || url.startsWith("https://")) return "URL";
    if (url.endsWith(".png") || url.endsWith(".jpg") || url.endsWith(".jpeg")) return "Image";
    if (url.endsWith(".pdf")) return "PDF";
    return "Other";
  };

  const handleViewQRCode = (qrcode) => {
    console.log("qrcode",qrcode)
    console.log("Base64 QR:", qrcode.qrcodeImage)
    let base64 = qrcode.qrcodeImage;
  if (!base64.startsWith("data:image")) {
    base64 = `data:image/png;base64,${base64}`;
  }
  const trackingUrl = `https://qrapi.emedha.in/track/${qrcode.id}`;
  setSelectedQRCode(base64);
  };

  const handleDownloadQRCode = () => {
    const a = document.createElement("a");
    a.href = selectedQRCode;
    a.download = "qrcode.png";
    a.click();
  };


  const handleDeleteQRCode = async (id) => {
    if (!window.confirm("Are you sure you want to delete this QR code?")) return;
  
    try {
      await axios.delete(`https://qrapi.emedha.in/qrcodes/delete/${id}`); // Your backend endpoint
      setQRCodes(prev => prev.filter(qr => qr.id !== id)); // Remove deleted QR from state
      alert("QR code deleted successfully.");
    } catch (error) {
      console.error("Error deleting QR code:", error);
      alert("Failed to delete QR code.");
    }
  };


  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);

    const filtered = qrcodes.filter((qr) => {
      const fileType = getFileType(qr.url).toLowerCase();
      const fileName = qr.url?.toLowerCase() || "";
      const date = new Date(qr.createdAt).toLocaleDateString().toLowerCase();
      return (
        fileType.includes(value) ||
        fileName.includes(value) ||
        date.includes(value)
      );
    });

    setFilteredQRCodes(filtered);
    setCurrentPage(1);
  };

  // Pagination logic
  const indexOfLast = currentPage * qrcodesPerPage;
  const indexOfFirst = indexOfLast - qrcodesPerPage;
  const currentQRCodes = filteredQRCodes.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredQRCodes.length / qrcodesPerPage);

  

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>My QR Codes</h1>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <input
        type="text"
        placeholder="Search by file name, type, or date"
        value={search}
        onChange={handleSearch}
        style={styles.searchInput}
      /></div>
      <table style={styles.table}>
        <thead>
          <tr style={styles.headerRow}>
            <th style={styles.headerCell}>File Type</th>
            <th style={styles.headerCell}>File Name</th>
            <th style={styles.headerCell}>Created At</th>
            <th style={styles.headerCell}>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentQRCodes.filter((ite=>ite.qrcodeImage!=='')).map((qrcode) => (
            <tr key={qrcode.id} style={styles.bodyRow}>
              <td style={styles.cell}>{getFileType(qrcode.url)}</td>
              <td style={styles.cell}>{qrcode.url.split("//").pop()}</td>
              <td style={styles.cell}>{new Date(qrcode.createdAt).toLocaleString()}</td>
              <td style={styles.cell1}>
                <button style={styles.viewButton} onClick={() => handleViewQRCode(qrcode)}>View</button>
                <button style={styles.deleteButton} onClick={() => handleDeleteQRCode(qrcode.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={styles.pagination}>
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          style={styles.pageButton}
        >
          Prev
        </button>
        <span style={styles.pageNumber}>Page {currentPage} of {totalPages}</span>
        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          style={styles.pageButton}
        >
          Next
        </button>
      </div>


      {selectedQRCode && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h2 style={{color:'blueviolet'}}>QR Code</h2>
            <img
  src={
    selectedQRCode.startsWith("data:image")
      ? selectedQRCode
      : `data:image/png;base64,${selectedQRCode}`
  }
  alt="QR Code"
  style={styles.qrImage}
/>

            <div style={styles.modalActions}>
              <button style={styles.downloadButton} onClick={handleDownloadQRCode}>
                Download
              </button>
              <button style={styles.closeButton} onClick={() => setSelectedQRCode(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    fontFamily: "'Arial', sans-serif",
    backgroundColor: "#f9f9f9",
    minHeight: "100vh",
    width:'100%'
  },
  heading: {
    textAlign: "start",
    marginBottom: "20px",
    color: "#333",
    fontSize:'25px'
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  },
  headerRow: {
    backgroundColor: "#007bff",
    color: "#fff",
  },
  headerCell: {
    padding: "10px",
    fontWeight: "bold",
    textAlign: "left",
    borderBottom: "2px solid #ddd",
  },
  bodyRow: {
    borderBottom: "1px solid #ddd",
  },
  cell: {
    padding: "10px",
    textAlign: "left",
  },
   cell1: {
    padding: "10px",
    textAlign: "center",
    width:'180px'
  },
  viewButton: {
    backgroundColor: "#007bff",
    color: "#fff",
    padding: "5px 10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  },
  deleteButton: {
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    marginLeft: "8px",
    cursor: "pointer",
    borderRadius: "4px"
  },
  
  viewButtonHover: {
    backgroundColor: "#0056b3",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
modalContent: {
  background: "rgba(255, 255, 255, 0.63)",
  backdropFilter: "blur(12px)",
  padding: "30px",
  borderRadius: "12px",
  width: "100%",
  maxWidth: "500px",
  textAlign: "center",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
},



  qrImage: {
    maxWidth: "250px",
    height: "250px",
    marginBottom: "15px",
  },
  modalActions: {
    display: "flex",
    width: "100%",
    padding: "20px",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",  // Center the buttons
    gap: "20px",  // Add some space between the buttons
  },
  
  downloadButton: {
    backgroundColor: "#28a745",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  closeButton: {
    backgroundColor: "#dc3545",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  searchInput: { marginBottom: 15, padding: 8, width: "100%", maxWidth: 400, border: "1px solid #ccc", borderRadius: 4 },
  pagination: { marginTop: 20, display: "flex", justifyContent: "center", alignItems: "center", gap: 10 },
  pageButton: { padding: "6px 10px", border: "1px solid #0056b3", backgroundColor: "#0056b3", color: "#fff", borderRadius: 4, cursor: "pointer" },
  pageNumber: { fontWeight: "bold" },
};

export default QRCodeTable;
